import { render, staticRenderFns } from "./PcIdxNumWmGraph.vue?vue&type=template&id=3fc08ddd&"
import script from "./PcIdxNumWmGraph.vue?vue&type=script&lang=js&"
export * from "./PcIdxNumWmGraph.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports